import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import format from 'date-fns/format'
import { getTrialDaysLeft, hasEndedUnchosenTrial, hasUnchosenTrial } from '@/utils/payments'
import { readStorage, writeStorage } from '@/utils/storage'

const PROMPT_DAYS_BEFORE_END = 3
const PLAN_CHOICE_PAGES = ['/plans', '/checkout', '/payment']

export const useTrialEndingPrompt = () => {
  const store = useStore()
  const route = useRoute()
  const router = useRouter()

  const promptKey = computed(() => {
    const activeSubscription = store.state.payments.activeSubscription

    if (!store.state.payments.isSubscriptionAdmin) {
      return null
    }

    if (hasEndedUnchosenTrial(activeSubscription)) {
      return `trialEndedPrompt:${activeSubscription.lastSubscriptionDetails.subscriptionId}`
    }

    const daysLeft = getTrialDaysLeft(activeSubscription)
    const isEndingSoon = daysLeft !== null && daysLeft >= 0 && daysLeft <= PROMPT_DAYS_BEFORE_END &&
      hasUnchosenTrial(activeSubscription)

    return isEndingSoon
      ? `trialEndingPrompt:${activeSubscription.subscriptionDetails.subscriptionId}:${format(new Date(), 'yyyy-MM-dd')}`
      : null
  })

  watch([promptKey, () => route.fullPath], ([key]) => {
    if (!key || !route.meta?.requiresAuth || PLAN_CHOICE_PAGES.includes(route.path) || readStorage(key)) {
      return
    }

    writeStorage(key, true)
    router.push({ path: '/plans', query: { from: route.fullPath } })
  })
}
